import React from "react";

const IconPaths = {
  flagCA: (
    <g fill="none" fillRule="nonzero" transform="translate(1 1)">
      <circle cx="6.981" cy="6.981" r="6.98" fill="#FFF" />
      <path
        fill="#D32027"
        d="M0 6.98a6.977 6.977 0 0 0 3.588 6.101V.88A6.978 6.978 0 0 0 0 6.98z"
      />
      <path
        fill="#FFF"
        d="M6.98 14.001c-.08 0-.157-.01-.236-.014.078.01.157.014.236.014z"
      />
      <path
        fill="#F3F1F2"
        d="M6.98 0h-.006.006c3.856 0 3.856 13.961 0 13.961 1.23 0 2.384-.319 3.387-.876V.876A6.948 6.948 0 0 0 6.98 0z"
      />
      <path
        fill="#D32027"
        d="M10.367.876v12.208a6.977 6.977 0 0 0 3.594-6.103A6.977 6.977 0 0 0 10.367.876z"
      />
      <path
        fill="#F3F1F2"
        d="M6.98 0h-.006a6.949 6.949 0 0 0-3.386.88V13.08c.94.524 2.013.838 3.156.876.079.001.156.004.236.004C10.836 13.96 10.836 0 6.98 0z"
      />
      <path
        fill="#D32027"
        d="M9.69 6.854c-.097-.091-.294-.081-.329-.234-.046-.374.126-.592.235-.842-.55.128-.984.34-.983-.281-.316.386-.656.772-.796.702-.2-.117.191-1.11.234-1.638-.193.088-.562.28-.562.28s-.335-.655-.513-.979V3.86v.001l-.002-.001v.003c-.177.324-.513.98-.513.98s-.369-.193-.561-.281c.042.527.433 1.521.233 1.638-.14.07-.48-.316-.795-.702 0 .621-.433.41-.983.28.108.25.28.469.234.843-.035.153-.232.143-.328.234.638.638 1.744 1.112 1.217 1.639l1.42-.133c.047.48-.103 1.069.027 1.397h.099c.134-.34-.018-.917.028-1.397l1.42.133c-.526-.527.58-1 1.217-1.639z"
      />
    </g>
  ),
  flagUS: (
    <g fill="none" fillRule="nonzero">
      <g fill="#C42126">
        <path d="M1.031 8.647H14.9v1H1.031zM1.754 4.844h12.424v1H1.754zM1.26 6.111h13.412v1H1.26zM3.994 13.752h7.944v-.001H3.993zM7.966 1.05c-.137 0-.273.016-.407.043h.814a2.135 2.135 0 0 0-.407-.043zM1.029 7.379h13.874v1H1.029z" />
      </g>
      <path
        fill="#F3F4F5"
        d="M10.025 3.577h3.326a7.001 7.001 0 0 0-1.363-1.267H9.49c.207.363.385.792.535 1.267z"
      />
      <path
        fill="#E73625"
        d="M9.49 2.31h2.498a6.927 6.927 0 0 0-3.615-1.268H8.16c.632.08.922.547 1.331 1.268z"
      />
      <path
        fill="#F3F4F5"
        d="M14.672 6.112a6.92 6.92 0 0 0-.494-1.268H10.35c.078.407.139.832.184 1.268h4.137z"
      />
      <path
        fill="#E73625"
        d="M10.136 4.844h4.042a6.97 6.97 0 0 0-.827-1.267H9.82c.124.394.23.819.315 1.267z"
      />
      <path
        fill="#F3F4F5"
        d="M10.682 8.646H14.9a6.997 6.997 0 0 0 .003-1.267h-4.22c.013.422.013.846-.001 1.267z"
      />
      <path
        fill="#E73625"
        d="M14.903 7.379a6.938 6.938 0 0 0-.231-1.267h-4.315c.044.415.072.84.086 1.267h4.46z"
      />
      <path
        fill="#F3F4F5"
        d="M10.278 11.181h3.882a6.91 6.91 0 0 0 .502-1.267h-4.196c-.046.436-.109.86-.188 1.267z"
      />
      <path
        fill="#E73625"
        d="M14.662 9.914c.117-.409.198-.832.238-1.267h-4.35c-.015.428-.044.852-.088 1.267h4.2z"
      />
      <path
        fill="#F3F4F5"
        d="M11.938 13.716a7.006 7.006 0 0 0 1.383-1.267h-3.268a6.474 6.474 0 0 1-.544 1.267h2.43z"
      />
      <g fill="#DC3027">
        <path d="M9.93 12.449h3.391c.324-.389.605-.814.839-1.268h-3.91c-.087.449-.194.874-.32 1.268zM7.771 14.993l-.1-.005.1.005zM7.966 14.961a6.933 6.933 0 0 0 3.972-1.245H9.417c-.448.771-.743 1.245-1.451 1.245z" />
      </g>
      <path fill="#C42126" d="M7.966 15.002z" />
      <path
        fill="#F3F4F5"
        d="M9.72 2.31H3.945c-.509.36-.968.786-1.363 1.267h7.674a6.622 6.622 0 0 0-.534-1.267z"
      />
      <path
        fill="#E73625"
        d="M3.944 2.31H9.72c-.41-.72-.93-1.188-1.562-1.268h-.6A6.927 6.927 0 0 0 3.943 2.31z"
      />
      <path
        fill="#F3F4F5"
        d="M1.26 6.112h9.495c-.045-.436-.107-.86-.184-1.268H1.754c-.204.402-.37.826-.494 1.268z"
      />
      <path
        fill="#E73625"
        d="M2.58 3.577c-.319.389-.596.814-.826 1.267h8.817a11.17 11.17 0 0 0-.316-1.267H2.581z"
      />
      <path
        fill="#F3F4F5"
        d="M1 7.995c0 .22.011.437.031.651h9.809c.014-.42.015-.845.001-1.267H1.029A7.04 7.04 0 0 0 1 7.995z"
      />
      <path
        fill="#E73625"
        d="M1.029 7.379h9.812a17.893 17.893 0 0 0-.086-1.267H1.26a6.93 6.93 0 0 0-.231 1.267z"
      />
      <path
        fill="#F3F4F5"
        d="M10.751 9.914H1.27c.126.442.295.866.502 1.267h8.792c.079-.406.141-.831.187-1.267z"
      />
      <path
        fill="#E73625"
        d="M1.27 9.914h9.481c.045-.415.074-.84.089-1.267H1.031c.04.435.122.858.239 1.267z"
      />
      <path
        fill="#F3F4F5"
        d="M3.993 13.716H9.7c.21-.362.392-.79.544-1.267H2.61c.402.482.867.908 1.383 1.267z"
      />
      <g fill="#E73625">
        <path d="M1.772 11.181c.234.454.515.879.838 1.268h7.634c.126-.394.233-.82.32-1.268H1.772zM7.671 14.955l.042.001c.084.003.168.005.253.005.708 0 1.286-.474 1.733-1.245H3.994a6.93 6.93 0 0 0 3.677 1.239z" />
      </g>
      <path
        fill="#283991"
        d="M7.822 1.033A6.964 6.964 0 0 0 1.03 7.368h6.792V1.033z"
      />
      <g fill="#EFEFEF">
        <path d="M2.394 4.976l.106.327h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM2.394 6.13l.106.327h.344l-.278.203.106.327-.278-.203-.278.203.106-.327-.278-.203h.344zM3.548 3.244l.107.327h.343l-.278.202.106.327-.278-.202-.278.202.107-.327-.279-.202h.344zM3.548 4.399l.107.327h.343l-.278.201.106.327-.278-.201-.278.201.107-.327-.279-.201h.344zM3.548 5.553l.107.327h.343l-.278.202.106.327-.278-.202-.278.202.107-.327-.279-.202h.344zM1.517 6.41l-.106-.328.278-.202h-.344l-.007-.024a6.668 6.668 0 0 0-.104.355l.005-.004.278.202zM2.116 4.677l.278-.202.278.202-.106-.327.278-.202H2.5l-.106-.327-.106.327H2.16a6.574 6.574 0 0 0-.07.108l.13.094-.105.327zM3.548 2.743l.278.202-.106-.327.278-.202H3.8c-.169.126-.332.26-.488.4l-.042.13.278-.203zM4.425 2.368l.278-.202.278.202-.106-.327.278-.202h-.344l-.014-.044c-.117.06-.232.121-.345.187l.081.059-.106.327zM4.703 2.667l.106.326h.344l-.278.203.106.327-.278-.203-.278.203.106-.327-.278-.203h.344zM4.703 3.821l.106.327h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM4.703 4.976l.106.327h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM4.703 6.13l.106.327h.344l-.278.203.106.327-.278-.203-.278.203.106-.327-.278-.203h.344zM5.858 2.09l.106.326h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.343zM5.858 3.244l.106.327h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.343zM5.858 4.399l.106.327h.344l-.278.201.106.327-.278-.201-.278.201.106-.327-.278-.201h.343zM5.858 5.553l.106.327h.344l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.343zM7.012 1.512l.107.327h.343l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM7.012 2.667l.107.326h.343l-.278.203.106.327-.278-.203-.278.203.106-.327-.278-.203h.344zM7.012 3.821l.107.327h.343l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM7.012 4.976l.107.327h.343l-.278.202.106.327-.278-.202-.278.202.106-.327-.278-.202h.344zM7.012 6.13l.107.327h.343l-.278.203.106.327-.278-.203-.278.203.106-.327-.278-.203h.344z" />
      </g>
    </g>
  ),
  flagGB: (
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g fill="#29337A">
          <path d="M2.237 4.074a6.994 6.994 0 0 0-1.006 2.19h3.195l-2.189-2.19zM6.057 1.31a7 7 0 0 0-2.219 1.103l2.22 2.22V1.31zM4.003 13.812c.62.433 1.311.769 2.054.985V11.76l-2.054 2.053zM1.312 10.128c.232.752.588 1.45 1.043 2.071l2.071-2.07H1.312z" />
        </g>
        <g fill="#FFF">
          <path d="M2.353 3.91l-.116.164 2.19 2.19H1.23a7.028 7.028 0 0 0-.129.6h4.205L2.353 3.912zM3.84 13.696c.054.04.109.078.163.116l2.054-2.054v3.039c.197.058.398.108.602.148v-4.067L3.84 13.696zM1.156 9.527c.043.203.095.404.156.601h3.114L2.355 12.2c.225.308.475.597.746.864l3.537-3.536H1.156zM6.057 1.31v3.322L3.838 2.413c-.306.228-.592.48-.857.754L6.66 6.844v-5.68c-.204.04-.405.09-.602.147z" />
        </g>
        <g fill="#D32030">
          <path d="M6.117 10.117l-.07.071h.07zM6.648 9.587h.07v-.072zM9.4 6.876h-.068v.068zM6.138 6.323l-.07-.07v.07zM6.67 6.854v.07h.07z" />
        </g>
        <path
          fill="#29337A"
          d="M9.922 13.242v1.575a6.984 6.984 0 0 0 2.083-.976l-1.707-1.706c-.136.479-.186.727-.376 1.107zM10.307 4.247l1.863-1.863a6.998 6.998 0 0 0-2.248-1.093V2.91c.22.438.238.772.385 1.338zM13.665 12.24a7.004 7.004 0 0 0 1.072-2.112h-3.184l2.112 2.112zM14.818 6.263a6.992 6.992 0 0 0-1.035-2.23l-2.23 2.23h3.265z"
        />
        <g fill="#FFF">
          <path d="M10.717 9.646l.483.482 2.31 2.31c.053-.065.105-.13.155-.198l-2.112-2.112h3.184c.061-.197.113-.397.156-.601h-4.13c-.007.085-.038.034-.046.119zM10.234 4.6l2.094-2.095a7.284 7.284 0 0 0-.158-.12l-1.863 1.862c.02.073-.09.277-.073.352zM9.922 2.78V1.29a7.011 7.011 0 0 0-.601-.14v.726c.223.242.424.547.601.902zM10.67 6.865h4.277a7.004 7.004 0 0 0-.13-.602h-3.265l2.23-2.23a7.06 7.06 0 0 0-.728-.88L10.54 5.663c.068.456.098.72.129 1.2zM10.197 12.033l1.808 1.808c.3-.207.583-.437.848-.688l-2.378-2.378c-.076.44-.166.865-.278 1.258zM9.32 14.148v.809c.205-.038.405-.085.602-.14v-1.575a3.907 3.907 0 0 1-.601.906z" />
        </g>
        <path
          fill="#E51D35"
          d="M10.541 5.664l2.512-2.512a7.023 7.023 0 0 0-.725-.647l-1.973 1.974c.087.366.127.786.186 1.185z"
        />
        <g fill="#D32030">
          <path d="M7.674 1.084zM8.024 15.124zM8.024 15.078a7.04 7.04 0 0 0 1.297-.121v-.81c-.37.4-.801.931-1.297.931z" />
        </g>
        <g fill="#E51D35">
          <path d="M14.947 6.865h-4.222c.056.88.05 1.787-.02 2.662h4.188a7.047 7.047 0 0 0 .054-2.662zM10.717 9.646c-.039.415-.175.738-.242 1.13l2.378 2.377c.235-.223.455-.461.657-.714l-2.31-2.31-.483-.483z" />
        </g>
        <path
          fill="#E51D35"
          d="M9.32 1.929v-.778a7.058 7.058 0 0 0-1.296-.121c.496 0 .928.5 1.297.899z"
        />
        <path
          fill="#29337A"
          d="M9.936 13.546c.3-.38.558-.819.774-1.298l-.774-.49v1.788zM10.806 4.082a6.379 6.379 0 0 0-.87-1.52v2.07l.87-.55z"
        />
        <path
          fill="#FFF"
          d="M10.854 9.782l.022-.255h-.278l.256.255zM9.922 4.53V2.561a3.885 3.885 0 0 0-.601-.902v3.853c1.523-1.488 2.28-2.257 2.267-2.307-.018-.076-.863.691-.882.618l-.784.705zM9.34 6.865h1.556c-.03-.48-.08-.953-.147-1.409L9.341 6.865zM9.922 13.546v-1.787l.784.791c.112-.393-.088-1.116-.012-1.555L9.321 9.62v4.827a3.89 3.89 0 0 0 .601-.902z"
        />
        <path
          fill="#E51D35"
          d="M9.32 14.448V9.621l1.374 1.374c.068-.392.12-.798.16-1.213l-.256-.255h.278c.069-.875.076-1.781.02-2.662H9.34l1.408-1.409c-.06-.399-.133-.785-.22-1.151L9.32 5.513V1.66c-.37-.4-.801-.63-1.297-.63a7.071 7.071 0 0 0-1.366.134v5.68L2.982 3.167a7.092 7.092 0 0 0-.628.744l2.352 2.352.602.602H1.102a7.062 7.062 0 0 0 .053 2.662h5.483L3.1 13.063c.232.227.478.44.74.633l2.818-2.818v4.067a7.078 7.078 0 0 0 1.365.133c.496 0 .928-.23 1.297-.63z"
        />
      </g>
    </g>
  ),
};

export default IconPaths;
